import {
  LOAD_CANDIDATE_RECORD,
  LOAD_CANDIDATE_RECORD_ERROR,
} from "../actions/types";

const initialState = {
  candidateData: null,
  errors: {},
  loading: true,
};

export default function candidateRecordReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_CANDIDATE_RECORD:
      return {
        ...state,
        loading: false,
        candidateData: payload,
        errors: {},
      };
    case LOAD_CANDIDATE_RECORD_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    default:
      return state;
  }
}
